import React from 'react'
import Select from 'react-select'

function SelectByValue(props) {

  // const [options, setoptions] = useState([]);

  let valueByProps = null;

  if(props.value && props.options){
    if(props.options.length > 0){
      valueByProps = props.options.find(item => item.value.toString() === props.value.toString());
    }
  }

  const onChangeData = (val) => {
    if(val !== null){
      props.onChange(val);
    }else{
      if(props.onChange){
        props.onChange(null);
      }
    }
  }

  return (
    <div>
        <Select 
          options={props.options}
          value={valueByProps}
          onChange={(val) => onChangeData(val)}
        />
    </div>
  )
}

export default SelectByValue